<div class="property-info">
    <div class="price-info paragraph">
        @if (selectedSale().judicialTransferDate || selectedSale().actualSaleDate) {
        <div class="entry">
            @if(selectedSale().actualSaleDate) {
            <span>Solgt {{ selectedSale().actualSaleDate | date : "dd.MM.yyyy" | dash }}</span>
            } @else{
            <span>Tinglyst {{ selectedSale().judicialTransferDate | date : "dd.MM.yyyy" | dash }}</span>
            }
            <span>{{ selectedSale().salesPrice | number : "1.0-0" | dash }}</span>
        </div>
        } @if(selectedSale().askingPrice) {
        <div class="entry">
            <span>Til salgs fra {{ selectedSale().informationDate | date : "dd.MM.yyyy" | dash }}</span>
            <span>{{ selectedSale().askingPrice | number : "1.0-0" | dash }}</span>
        </div>
        }
    </div>

    @if (selectedSale().estateAgent) {
    <div class="estate-agent paragraph">{{ selectedSale().estateAgent }}</div>
    }
    <mini-infocard-realestate-properties [keyInfo]="selectedSale()"></mini-infocard-realestate-properties>

    <div class="links">
        <a target="_blank" [routerLink]="['/resolve/infopage']" [queryParams]="{ unitID: selectedSale().unitId }" class="open-in-evinfo">
            <span>Åpne i evInfo</span>
            <div class="external-link-icon"></div>
        </a>
        @if (selectedSale().sourceUrl) {
        <a [href]="selectedSale().sourceUrl" target="_blank" class="see-finn">
            <div class="finn-icon"></div>
            <span>Se Finn-annonse</span>
            <div class="external-link-icon"></div>
        </a>
        }
    </div>
</div>
